export const RESTAURANT_MENU_TEMPLATE_OPTIONS = [
  {
    value: 'classic_warm',
    label: 'Classic Warm',
    description: 'Nuansa krem hangat untuk restoran keluarga dan cafe santai.',
  },
  {
    value: 'garden_fresh',
    label: 'Garden Fresh',
    description: 'Hijau segar untuk outlet sehat, salad bar, dan cafe natural.',
  },
  {
    value: 'sunset_bistro',
    label: 'Sunset Bistro',
    description: 'Oranye keemasan untuk outlet casual dining dan menu ramai.',
  },
  {
    value: 'urban_night',
    label: 'Urban Night',
    description: 'Tampilan gelap modern untuk coffee bar dan dining malam.',
  },
];

export function normalizeRestaurantMenuTemplate(value) {
  const normalized = String(value || '').trim().toLowerCase();
  return RESTAURANT_MENU_TEMPLATE_OPTIONS.some(option => option.value === normalized)
    ? normalized
    : 'classic_warm';
}

export function extractNullableString(value) {
  if (typeof value === 'object' && value !== null) {
    return value.String ?? value.string ?? value.value ?? '';
  }

  return String(value || '');
}

export function supportsRestaurantMenuTheme(outletType) {
  return ['restaurant', 'cafe_gym', 'cafe_store'].includes(String(outletType || '').trim());
}
